import { render, staticRenderFns } from "./PriceCalculator.vue?vue&type=template&id=88bf6266&scoped=true&"
import script from "./PriceCalculator.vue?vue&type=script&lang=js&"
export * from "./PriceCalculator.vue?vue&type=script&lang=js&"
import style0 from "./PriceCalculator.vue?vue&type=style&index=0&id=88bf6266&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88bf6266",
  null
  
)

export default component.exports